import React from "react";
import type { Attachment } from "src/types/conditionsInbox";
import {
  AttachmentsSection,
  AttachmentsHeader,
  NoAttachmentsMessage,
  AttachmentsList,
  AttachmentItem,
  AttachmentInfo,
  AttachmentName,
  AttachmentMeta,
} from "./EmailDetailSection.styles";
import { FilesIcon } from "lucide-react";
import { FilePDFIcon, FileDOCIcon } from "src/assets/icons";

interface AttachmentsProps {
  attachments: Attachment[];
  renamedAttachments?: Record<string, string>;
  selectedAttachmentsId?: Set<string>;
  onClickAttachment: React.MouseEventHandler<HTMLDivElement>;
}

const getFileIcon = (fileType: string) => {
  const type = fileType.toLowerCase();
  if (type === "pdf") return <FilePDFIcon />;
  if (type === "doc" || type === "docx") return <FileDOCIcon />;
  return <FilesIcon />;
};

export const Attachments: React.FC<AttachmentsProps> = ({
  attachments,
  renamedAttachments = {},
  selectedAttachmentsId,
  onClickAttachment,
}) => {
  const getDisplayName = (attachment: Attachment) => {
    return renamedAttachments[attachment.id] || attachment.name;
  };

  return (
    <AttachmentsSection>
      <AttachmentsHeader>Attachments ({attachments.length})</AttachmentsHeader>

      {attachments.length === 0 ? (
        <NoAttachmentsMessage>No attachments</NoAttachmentsMessage>
      ) : (
        <AttachmentsList>
          {attachments.map((attachment) => (
            <AttachmentItem
              key={attachment.id}
              data-id={attachment.id}
              selected={selectedAttachmentsId?.has(attachment.id) ?? false}
              onClick={onClickAttachment}
            >
              {getFileIcon(attachment.type)}
              <AttachmentInfo>
                <AttachmentName>{getDisplayName(attachment)}</AttachmentName>
                <AttachmentMeta>
                  {attachment.size} • {attachment.type.toUpperCase()}
                </AttachmentMeta>
              </AttachmentInfo>
            </AttachmentItem>
          ))}
        </AttachmentsList>
      )}
    </AttachmentsSection>
  );
};
